/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Configuration for API key in query parameter. Must be provided if type is in-query.
 * @export
 * @interface ApiKeyOptsQuery
 */
export interface ApiKeyOptsQuery {
    /**
     * The name of the query parameter to be used for the API key.
     * @type {string}
     * @memberof ApiKeyOptsQuery
     */
    name: string;
}

/**
 * Check if a given object implements the ApiKeyOptsQuery interface.
 */
export function instanceOfApiKeyOptsQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ApiKeyOptsQueryFromJSON(json: any): ApiKeyOptsQuery {
    return ApiKeyOptsQueryFromJSONTyped(json, false);
}

export function ApiKeyOptsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyOptsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function ApiKeyOptsQueryToJSON(value?: ApiKeyOptsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

